var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "filtered-search-container"
  }, [_c('h2', {
    staticClass: "p-2 heading"
  }, [_vm._v(_vm._s(_vm.$t("Filters")))]), _c('div', {
    staticClass: "filters-container px-2"
  }, _vm._l(_vm.filters, function (filter, key) {
    return _c('div', {
      key: key,
      staticClass: "filter-item"
    }, [_c('div', {
      staticClass: "mb-3 d-flex flex-column input-group search-input-wrapper w-100"
    }, [_c('label', {
      staticClass: "mb-2 filter-label",
      attrs: {
        "for": `flexCheckDefault-${key}`
      }
    }, [_vm._v(" " + _vm._s(filter.label) + " ")]), _c('input', {
      staticClass: "search-input w-100",
      attrs: {
        "type": "text",
        "autocomplete": "nope",
        "placeholder": "Search..."
      },
      domProps: {
        "value": _vm.searchTerms[key]
      },
      on: {
        "input": function ($event) {
          _vm.handleInput(key.toString(), $event);
        }
      }
    })])]);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }